(function () {
  if (window.__spCartQtyFormat) return;
  window.__spCartQtyFormat = 1;

  var CART = '[data-section-type="cart-template"]';
  var nativeValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

  function digits(s) { return ('' + s).replace(/\D+/g, ''); }
  function group(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function paint(input, editing) {
    var raw = digits(nativeValue.get.call(input));
    nativeValue.set.call(input, editing ? raw : (raw ? group(raw) : ''));
  }

  function bind(input) {
    if (input.__spQtyBound) return;
    input.__spQtyBound = 1;

    if (input.type === 'number') {
      input.type = 'text';
      input.setAttribute('inputmode', 'numeric');
    }

    Object.defineProperty(input, 'value', {
      configurable: true,
      get: function () { return digits(nativeValue.get.call(this)); },
      set: function (v) {
        nativeValue.set.call(this, digits(v));
        paint(this, document.activeElement === this);
      }
    });

    input.addEventListener('focus', function () { paint(input, true); });
    input.addEventListener('blur', function () { paint(input, false); });
    input.addEventListener('input', function () {
      var raw = digits(nativeValue.get.call(input));
      if (nativeValue.get.call(input) !== raw) nativeValue.set.call(input, raw);
    });

    paint(input, document.activeElement === input);
  }

  function scan() {
    document.querySelectorAll(CART + ' [data-quantity-input]').forEach(bind);
  }

  function init() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (window.SPCore && SPCore.DOMready) SPCore.DOMready(init);
  else document.addEventListener('DOMContentLoaded', init);
})();
